import {
  SlSelect
} from "./chunk.QIAOCRSS.js";

// src/components/select/select.ts
var select_default = SlSelect;
SlSelect.define("sl-select");

export {
  select_default
};
